<template>
    <div class="menu_page">
        <el-row >
            <el-col>
                <el-menu
                        mode="vertical"
                        :collapse="isCollapse"
                        background-color="#FFFFFF"
                        text-color="#303133"
                        active-text-color="#409eff"
                        :default-active="currentMenu"
                        @select="handleMenuSelect"
                        class="el-menu-vertical-demo">
                    <router-link to="/index">
                        <el-menu-item index="0">
                            <i class="el-icon-s-fold"></i>
                            <span slot="title">首页</span>
                        </el-menu-item>
                    </router-link>
                    <template  v-for="item in menuList">
                        <el-submenu v-if="item.children.length > 0" :index="item.id+''" :key="item.id">
                            <template slot="title">
                                <i :class="item.icon"></i>
                                <span slot="title">{{item.name}}</span>
                            </template>
                            <router-link v-for="(citem,cindex) in item.children"
                                         :to="citem.path" :key="cindex">
                                <el-menu-item :index="citem.id+''">
                                    <i :class="citem.icon"></i>
                                    <span slot="title">{{citem.name}}</span>
                                </el-menu-item>
                            </router-link>
                        </el-submenu>
                        <router-link :to="item.path">
                            <el-menu-item v-if="item.children.length==0" :index="item.id+''">
                                <i :class="item.icon"></i>
                                <span slot="title">{{item.name}}</span>
                            </el-menu-item>
                        </router-link>
                    </template>
                </el-menu>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    export default {
        name: "leftmenu",
        computed: {
            menuList() {
                return this.$store.getters.userinfo.menuList;
            }
        },
        props: ['isCollapse'],
        data() {
            return {
                currentMenu: '0'
            };
        },
        created(){
            this.getUrl();
        },
        methods:{
            getUrl(){
                this.currentMenu = (this.$store.state.curPage == null? "0" : this.$store.state.curPage)
            },
            handleMenuSelect(index,indexPath){
                if(indexPath.length == 1 && indexPath[0] == '0'){
                    this.$store.commit("SAVABREADNAV", '')
                }else{
                    let menus = this.$store.getters.userinfo.menus
                    if(menus != null){
                        var arr1 = indexPath.map(function(x){
                            var result = menus.find(v => v.id == x)
                            return result.name
                        })
                        this.$store.commit("SAVABREADNAV", arr1)
                    }

                }
            }
        },
        watch: {
            '$route' (to, from) {
                let menus = this.$store.getters.userinfo.menus
                if(menus != null){
                    var result = menus.find(v => v.path == to.fullPath)
                    if(result != null){
                        this.$store.commit("curPage", result.id+'')
                    }else{
                        this.$store.commit("curPage", "0")
                    }
                }
            }
        }
    };
</script>
<style lang="scss">
    .menu_page {
        .el-menu-vertical-demo:not(.el-menu--collapse) {
            width: 180px;
            min-height: 400px;
        }
        .el-menu-vertical-demo {
            width: 60px;
        }
        .el-submenu .el-menu-item {
            min-width: 180px;
        }

        .hiddenDropdown,
        .hiddenDropname {
            display: none;
        }
        a {
            text-decoration: none;
        }
    }
</style>
